import { useState } from "react";
import type { Release } from "@/content/site";

export function CoverTile({
  release,
  index,
  testId,
}: {
  release: Release;
  index?: number;
  testId?: string;
}) {
  const [failed, setFailed] = useState(false);
  const hasArt = Boolean(release.cover) && !failed;

  return (
    <div
      data-testid={testId}
      className="group relative aspect-square w-full overflow-hidden border border-white/10 bg-eve-surface transition-transform duration-500 hover:-translate-y-1"
    >
      {hasArt ? (
        <>
          <img
            src={release.cover}
            alt={`${release.title} — official cover art`}
            loading="lazy"
            decoding="async"
            onError={() => setFailed(true)}
            className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
          />
          <div
            className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100"
            style={{ boxShadow: `inset 0 0 90px ${release.accent}40` }}
          />
          {typeof index === "number" && (
            <span className="absolute left-4 top-4 bg-eve-bg/70 px-2 py-1 font-mono text-[10px] tracking-[0.35em] text-white/70 backdrop-blur-sm">
              {String(index).padStart(2, "0")}
            </span>
          )}
        </>
      ) : (
        <>
          <div
            className="absolute inset-0"
            style={{
              background: `radial-gradient(circle at 72% 18%, ${release.accent}1f, transparent 62%)`,
            }}
          />
          {typeof index === "number" && (
            <span className="absolute left-5 top-5 font-mono text-[10px] tracking-[0.35em] text-white/30">
              {String(index).padStart(2, "0")}
            </span>
          )}
          <span className="absolute right-5 top-5 font-mono text-[10px] uppercase tracking-[0.3em] text-white/30">
            {release.type}
          </span>
          <div className="absolute inset-x-5 bottom-5">
            <div className="mb-4 h-[3px] w-9" style={{ background: release.accent }} />
            <span className="font-display text-3xl uppercase leading-[0.95] text-white/90 transition-colors duration-500 group-hover:text-white sm:text-4xl lg:text-[2.6rem]">
              {release.title}
            </span>
          </div>
          <div
            className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100"
            style={{ boxShadow: `inset 0 0 90px ${release.accent}1a` }}
          />
        </>
      )}
    </div>
  );
}
